import Button from '@ingka/button';
import SSRIcon from '@ingka/ssr-icon';
import arrowLeftPath from '@ingka/ssr-icon/paths/arrow-left';
import arrowRightPath from '@ingka/ssr-icon/paths/arrow-right';
import folderPath from '@ingka/ssr-icon/paths/folder';
import Text from '@ingka/text';
import { useNavigate } from 'react-router';
import { useApp } from '@/context/AppContext';
import styles from './ClassificationStep.module.css';

export default function ClassificationStep() {
  const navigate = useNavigate();
  const { catalog, setClassification } = useApp();
  const goBack = () => navigate('/upload/entity');

  const pick = (classificationId: string) => {
    setClassification(classificationId);
    navigate('/upload/file');
  };

  return (
    <div className={styles.page}>
      <Button
        type="tertiary"
        size="small"
        text="Back to entity"
        ssrIcon={arrowLeftPath}
        iconPosition="leading"
        onClick={goBack}
        className={styles.backBtn}
      />
      <div className={styles.hero}>
        <Text tagName="h2" textStyle="Heading.XL" className={styles.heroTitle}>
          What classification is this for?
        </Text>
        <Text tagName="p" textStyle="Body.L" className={styles.heroBody}>
          Choose the classification that applies to this data. This decides the schema and where the
          file is routed.
        </Text>
      </div>

      <div className={styles.grid}>
        {(catalog?.classifications ?? []).map((p) => (
          <button key={p.id} type="button" onClick={() => pick(p.id)} className={styles.card}>
            <div className={styles.cardTop}>
              <div className={styles.cardIcon}>
                <SSRIcon paths={folderPath} />
              </div>
              <SSRIcon paths={arrowRightPath} className={styles.cardArrow} />
            </div>
            <Text tagName="h3" textStyle="Heading.L" className={styles.cardName}>
              {p.name}
            </Text>
            <Text tagName="p" textStyle="Body.S" className={styles.cardDesc}>
              {p.description ?? ''}
            </Text>
          </button>
        ))}
      </div>
    </div>
  );
}
